/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import {Layout} from "../_igad/layout";
import BasePage from "./BasePage";
import { Logout, AuthPage, LandingPage} from "./modules/Auth";
import ErrorsPage from "./modules/Error/ErrorsPage";

export function Routes() {
    const {isAuthorized} = useSelector(
        ({auth}) => ({
            isAuthorized: auth.user != null,
        }),
        shallowEqual
    );
    
    return (
        <Switch>
            <Route path="/logout" exact={true}  component={Logout}/>
            {!isAuthorized ? (
                /*Render auth page when user at `/auth` and not authorized.*/
                <Route path="/" exact={true} component={LandingPage} />
            ) : (
                /*Otherwise redirect to root page (`/`)*/
                <Layout>
                    <BasePage/>
                </Layout>
            )}
            {!isAuthorized ? (
                /*Render auth page when user at `/auth` and not authorized.*/
                <Route path="/home" exact={true}  component={LandingPage} />
            ) : (
                /*Otherwise redirect to root page (`/`)*/
                <Layout>
                    <BasePage/>
                </Layout>
            )}
            
            
            {!isAuthorized ? (
                /*Render auth page when user at `/auth` and not authorized.*/
                <Route>
                    <AuthPage />
                </Route>
            ) : (
                /*Otherwise redirect to root page (`/`)*/
                <Redirect from="/auth" to="/"/>
            )}
            {!isAuthorized ? (
                /*Redirect to `/auth` when user is not authorized*/          
                <Redirect  to="/auth"/>
            ) : (
                <Layout>
                    <BasePage/>
                </Layout>
            )}

            <Route path="/error" exact={true}  component={ErrorsPage}/>
        </Switch>
    );
}
